import React, { Suspense, lazy, useEffect } from 'react';

import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Spinner } from 'reactstrap';

import { MCCard } from '../../components/mc';
import { t } from '../../i18n';
import { fetchProfileData } from '../../store/auth/profile/actions';
import WalletConfirmErrorBoundary from '../Authentication/components/Profile/WalletConfirmErrorBoundary';
import Notifications from '../Notifications/Notifications';
import SupportCard from './SupportCard/SupportCard';
import WelcomeComp from './WelcomeComp.jsx';
import './dashboard.scss';

// Lazy + error-boundaried: a failure in the wallet/web3modal stack rejects the dynamic import and is
// contained by the boundary — it can never blank the dashboard.
const WalletConfirmDashboard = lazy(() => import('./WalletConfirm/WalletConfirmDashboard'));
const PropAccountsDashboard = lazy(() => import('./PropAccounts/PropAccountsDashboard'));

const Dashboard = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.Profile.user);

  useEffect(() => {
    dispatch(fetchProfileData());
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t('dashboard_meta_title')}</title>
        </MetaTags>
        <div className="dashboard-grid">
          <div className="dashboard-pane dashboard-pane--wallet">
            <WalletConfirmErrorBoundary fallback={null}>
              <Suspense fallback={<Spinner size="sm" />}>
                <WalletConfirmDashboard />
              </Suspense>
            </WalletConfirmErrorBoundary>
          </div>
          {user && (
            <MCCard pad="md" className="dashboard-pane dashboard-pane--user">
              <WelcomeComp user={user} />
            </MCCard>
          )}
          <div className="dashboard-pane dashboard-pane--rail">
            <div className="dashboard-pane--prop">
              <WalletConfirmErrorBoundary fallback={null}>
                <Suspense fallback={<Spinner size="sm" />}>
                  <PropAccountsDashboard />
                </Suspense>
              </WalletConfirmErrorBoundary>
            </div>
            <SupportCard />
            <MCCard pad="md" className="dashboard-pane--notifications">
              <Notifications />
            </MCCard>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
  success: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(connect(mapStatetoProps, {})(withTranslation()(Dashboard)));
